import { Link } from "react-router-dom";

const stats = [
  { value: "1,500+", label: "Students Certified" },
  { value: "100%", label: "AHA Aligned" },
  { value: "Same-Day", label: "Certification Available" },
];

export default function AboutPreview() {
  return (
    <section className="py-0 bg-white overflow-hidden">
    </section>
  );
}
